import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { GeneralInfoForm } from "./GeneralInfoForm";
import { useThemeStore } from "../../../../../store/useThemeStore";

export const HtmlContent = ({ onNext, onPrevious, currentStep, totalSteps }) => {
  const { themeColor } = useThemeStore();

  return (
    <div style={{ padding: "16px" }}>
      <GeneralInfoForm />

      {/* ── Footer navigation ──────────────────────────────────────────── */}
      <div style={{
        display: "flex", justifyContent: "flex-end", alignItems: "center",
        gap: 10, marginTop: 20, paddingTop: 16,
        borderTop: "1px solid #f0f1f3",
      }}>
        {currentStep > 1 && (
          <Button
            icon={<LeftOutlined />} onClick={onPrevious}
            style={{ height: 38, borderRadius: 9, fontWeight: 600, fontSize: 13, borderColor: "#e5e7eb", color: "#374151" }}
          >
            Previous
          </Button>
        )}
        {currentStep < totalSteps && (
          <Button
            icon={<RightOutlined />} iconPosition="end" onClick={onNext}
            style={{ height: 38, borderRadius: 9, fontWeight: 700, fontSize: 13, background: themeColor, borderColor: themeColor, color: "#fff", boxShadow: `0 2px 8px ${themeColor}44`, transition: "background 0.3s" }}
          >
            Save & Next
          </Button>
        )}
      </div>
    </div>
  );
};
